import { css } from 'styled-components';

import colors from 'styles/colors';

export const tabBaseStyles = css`
  color: ${colors.gray_scale10};
  font-size: 13px;
  cursor: pointer;
  text-align: center;
  padding: 0 3px;
  white-space: pre-line;
`;

export const tabActiveStyles = css`
  font-weight: 600;
  color: ${colors.brand_2};
  &::after {
    content: '';
    display: block;
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background-color: ${colors.brand_2};
    margin: 5px auto;
  }
`;
